export const URL_GET_GENERAL_CONFIG = '/v1/gocheckin/settings/site/get-general-config'
export const URL_UPDATE_GENERAL_CONFIG = '/v1/gocheckin/settings/form/update-general-config'
export const URL_GET_CHECKOUT_CONFIG = '/v1/gocheckin/settings/site/get-checkout-config'
export const URL_UPDATE_CHECKOUT_CONFIG = '/v1/gocheckin/settings/form/update-checkout-config'
export const URL_GET_KEY_STORAGE = '/v1/settings/key-storage/get?'
export const URL_ADD_KEY_STORAGE = '/v1/settings/key-storage/add'
export const URL_UPDATE_KEY_STORAGE = '/v1/settings/key-storage/update'
export const URL_UPDATE_LIST_KEY_STORAGE = '/v1/settings/key-storage/update-list'
// export const URL_UPDATE_TERM_POLICY = '/v1/settings/key-storage/update'

export const URL_GET_TICKET_LIST = '/v1/gocheckin/ticket/site/info'
export const URL_GET_BLOCK_LIST = '/v1/gocheckin/ticket/site/list-block-name'
export const URL_CREATE_TICKET_TEMPLATE = '/v1/gocheckin/ticket/form/create'
export const URL_DELETE_TICKET_TEMPLATE = '/v1/gocheckin/ticket/form/delete?'
export const URL_UPDATE_TICKET_TEMPLATE = '/v1/gocheckin/ticket/form/update?'
export const URL_MOVE_SUBJECT = '/v1/gocheckin/ticket/form/subject-move'

// export const URL_GET_TICKET_LIST = '/v1/pos/ticket/site/info?'
// export const URL_GET_BLOCK_LIST = '/v1/pos/ticket/site/list-block-name'
// export const URL_CREATE_TICKET_TEMPLATE = '/v1/pos/ticket/form/create'
// export const URL_DELETE_TICKET_TEMPLATE = '/v1/pos/ticket/form/delete?'
// export const URL_UPDATE_TICKET_TEMPLATE = '/v1/pos/ticket/form/update?'
// export const URL_MOVE_SUBJECT = '/v1/pos/ticket/form/subject-move?'
// export const URL_SET_DEFAULT_TICKET_TEMPLATE = '/v1/pos/ticket/site/set-default-ticket-template'

export const URL_CHANGE_PASSWORD = '/v1/user/form/change-password'
export const URL_GET_BUSINESS_WORK_HOUR = '/v1/gocheckin/settings/business-work-hour/get?'
export const URL_UPDATE_BUSINESS_WORK_HOUR = '/v1/gocheckin/settings/business-work-hour/update'
export const URL_GET_SMS_CONTENT = '/v1/appointment/settings/site/get-sms-content'
export const URL_UPDATE_SMS_CONTENT = '/v1/appointment/settings/form/update-sms-content'
export const URL_GET_POLICIES = "/v1/gocheckin/settings/site/get-policies"
// export const URL_UPDATE_POLICIES = "/v1/gocheckin/settings/form/update-policies"
export const URL_UPDATE_TERM_POLICY = '/v1/gocheckin/settings/form/update-policies'
export const URL_GET_TAX = '/v1/pos/setting/site/tax-setting'
export const URL_UPDATE_TAX = "/v1/pos/setting/form/update-tax"
export const URL_GET_TIP = '/v1/pos/setting/site/get-tip'
export const URL_UPDATE_TIP = '/v1/pos/setting/form/update-tip'

export const URL_SET_DEFAULT_TICKET_TEMPLATE = "/v1/gocheckin/ticket/site/set-default-ticket-template"
export const URL_GET_SERVICE_FEE = "/v1/gocheckin/settings/site/get-service-fee";
export const URL_UPDATE_SERVICE_FEE ="/v1/gocheckin/settings/form/update-service-fee";
export const URL_GET_STORE_RATING_DISPLAY = "/v1/gocheckin/settings/site/store-rating-display";
export const URL_UPDATE_STORE_RATING_DISPLAY = "/v1/gocheckin/settings/form/update-store-rating-display";
export const URL_RELEASE_QR_CODE = "v1/pos/checkout/order/release-qr-code"